module.exports = __webpack_public_path__ + "img/task_assigned_by.58d8492e.svg";